import React from "react";

import styles from "./styles.module.scss";

interface LegendItemProps {
  className?: string;
  symbolClassName?: string;
  icon?: React.ReactNode;
  label: string;
  color: string;
  radius?: number;
  maxRadius?: number;
}

const LegendItem: React.FC<LegendItemProps> = ({
  className: classNameFromProps = "",
  symbolClassName = "",
  icon,
  label,
  color,
  radius = 5,
  maxRadius = 5,
}) => {
  const className = `${classNameFromProps} ${styles.legendItem}`.trim();

  return (
    <div className={className}>
      {icon ? (
        <div className={styles.icon} style={{ color }}>
          {icon}
        </div>
      ) : (
        <div
          className={`${styles.color} ${symbolClassName}`}
          style={{
            backgroundColor: color,
            width: `${2 * radius}px`,
            height: `${2 * radius}px`,
            // margin: `${maxRadius - radius}px`,
          }}
        />
      )}
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default LegendItem;
